import { RouteConfig } from "vue-router";

export const REmployerEmployeeCompanyDataHistory: RouteConfig = {
  path: "history",
  component: () =>
    import(
      /* webpackChunkName: "employer-employee-company-data-history" */
      "./VEmployerEmployeeCompanyDataHistory.vue"
    ),
  meta: {
    title: "Employees",
    label: "data history",
    tabName: "employer_employee_company_data_history",
    alias: "data_history",
  },
};
